import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import favicon from '../../../images/favicon.png';

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query SiteMetadata {
      site {
        siteMetadata {
          title
          description
          image
          siteUrl
        }
      }
    }
  `);

  return data.site.siteMetadata;
};

export const SEO = ({
  title,
  description,
  pathname,
  imagePath,
  children,
}: {
  title: string;
  description?: string;
  pathname?: string;
  imagePath?: string | null;
  children?: React.ReactNode;
}) => {
  const { title: defaultTitle, description: defaultDescription, image, siteUrl, twitterUsername } = useSiteMetadata();
  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${imagePath ? imagePath : image}`,
    url: `${siteUrl}${pathname || ``}`,
    twitterUsername,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <link rel="icon" type="image/png" sizes="16x16" href={favicon} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      {children}
    </>
  );
};
